<template>
	<div v-if="visible" class="info_dialog">
		<div class="dialog_content">
			<div class="info_header">
				<div class="title">
					<span>填写信息</span>
					<span class="close" @click="visible = false">
						<i class="el-icon-close"></i>
					</span>
				</div>
				<div class="desc">为了更好展示团队的情况，请填写以下信息</div>
			</div>
			<el-form :model="form" :rules="rules" ref="form" class="info_form">
				<el-form-item label="姓名:" :label-width="formLabelWidth" prop="nick_name">
					<el-input
						v-model="form.nick_name"
						autocomplete="off"
						placeholder="请输入姓名"
					></el-input>
				</el-form-item>
				<el-form-item label="部门:" :label-width="formLabelWidth" prop="department">
					<el-input
						v-model="form.department"
						autocomplete="off"
						placeholder="请输入部门"
					></el-input>
				</el-form-item>
				<el-form-item label="备注:" :label-width="formLabelWidth" prop="remarks">
					<el-input
						type="textarea"
						v-model="form.remarks"
						autocomplete="off"
						maxlength="20"
						show-word-limit
						placeholder="请输入内容"
					></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="visible = false">稍后设置</el-button>
				<el-button type="primary" @click="submitForm">保存</el-button>
			</div>
		</div>
	</div>
</template>

<script>
import { Template, Member } from '@/config/axios/new_api'
import { mapActions } from 'vuex'
export default {
	data() {
		return {
			visible: true,
			form: {
				nick_name: '',
				department: '',
				remarks: '',
			},
			formLabelWidth: '60px',
			rules: {
				nick_name: [
					{
						required: true,
						message: '请输入姓名',
						trigger: 'blur',
					},
					{ min: 2, max: 10, message: '长度在2到10个字符', trigger: 'blur' },
				],
				department: [
					{ min: 2, max: 20, message: '长度在2到20个字符', trigger: 'blur' },
				],
				remarks: [{ min: 2, max: 20, message: '长度在2到20个字符', trigger: 'blur' }],
			},
		}
	},
	created() {
		if (tokenFunc.getToken()) {
      this.getCurrentTeam();
    }
	},
	computed: {
		loginInfo() {
			return this.$store.getters.loginInfo
		},
	},
	methods: {
		...mapActions(['loginInfo']),
		async getCurrentTeam() {
			let res = await Member.getCurrentTeam()
			if (res.status == 1) {
				this.visible = res.data.corp_id && !this.loginInfo.nick_name
			}
			this.loginInfo.teams.forEach(item => {
				if (item.team_id === this.loginInfo.current_team_id) {
					this.form = {
						nick_name: this.loginInfo.nick_name,
						department: item.department,
						remark: item.remarks,
					}
				}
			})
		},
		submitForm() {
			this.$refs['form'].validate(valid => {
				if (valid) {
					Template.upUserInfo(this.form).then(res => {
						if (res.status == 1) {
							this.visible = false
							this.$store.dispatch('loginInfo')
							this.$message.success('更新成功！')
						}
					})
				} else {
					this.$message.error('请填写信息！')
					return false
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.info_dialog {
	width: 100%;
	height: 100%;
	position: fixed;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.5);
	z-index: 1999;
	.dialog_content {
		width: 424px;
		min-height: 540px;
		background-color: #fff;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		display: flex;
		flex-direction: column;
		.info_header {
			width: 100%;
			height: 124px;
			padding: 32px;
			.title {
				width: 100%;
				height: 18px;
				margin-bottom: 24px;
				display: flex;
				justify-content: space-between;
				font-size: 18px;
				color: #3b3946;
				font-weight: bold;
				font-family: PingFangSC-Semibold, PingFang SC;
				.close {
					cursor: pointer;
				}
			}
			.desc {
				width: 100%;
				height: 18px;
				font-size: 14px;
				color: #3b3946;
			}
		}
	}
}
.info_form {
	padding: 0 32px;
	.el-form-item {
		.el-form-item__content {
			.el-textarea {
				::v-deep(.el-textarea__inner) {
					height: 150px;
					resize: none;
				}
			}
		}
	}
}
.dialog-footer {
	padding: 0 32px;
	text-align: right !important;
	.el-button {
		font-weight: bold;
		color: #2d2d32;
		border-color: #e1e1e1;
		width: 88px;
		height: 40px;
		text-align: center;
		padding: 0;
	}
	.el-button--primary {
		color: #fff;
	}
}
</style>
